import styled, { css } from 'styled-components';
import { Form } from '@unform/web';

interface StatuProps {
  status: string;
}

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  position: fixed;
	top: 0;
  z-index: 99999999999999;
`;

export const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  width: auto;
  height: auto;
  border-radius: 5px;
  padding: 50px;

  @media (max-width: 430px) {
    width: 95%;
    padding: 30px;
  }
`;

export const ModalContent = styled.div<StatuProps>`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;

  h1 {
    font-size: 20px;
    font-weight: 500;
  }

  h2 {
    font-size: 20px;
    font-weight: 500;
  }

  .venda {
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 8px;
    border: 1px solid var(--gray-border-lg);
    padding: 10px;
    margin: 10px;
    width: 100%;
    color: #455a64;

    span {
      ${props =>
        props.status === 'CANCELADO'
          ? css`
              color: #b71c1c;
            `
          : props.status === 'CONCLUÍDO'
          ? css`
              color: #1b5e20;
            `
          : props.status === 'CONFIRMADA'
          ? css`
              color: #1b5e20;
            `
          : props.status === 'COM ENTREGADOR'
          ? css`
              color: #1a83ff;
            `
          : props.status === 'EM PREPARO'
          ? css`
              color: #1a83ff;
            `
          : css`
              color: #ff6f00;
            `}
    }
  }

  .div-btn {
    display: flex;
    justify-content: center;
    align-items: center;

    button {
      background: #2196f3;
      color: #fff;
			font-weight: 600;
      border-radius: 8px;
      padding: 10px 30px;
      margin: 20px 5px 5px 5px;
    }

    .btn-cancel {
      background: #cfd8dc;
      color: #333;
    }
  }

  @media (max-width: 430px) {
    img {
      width: 40px;
      height: 40px;
    }
  }
`;

export const FormView = styled(Form)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;

  div.input {
    display: flex;
    flex-direction: column;

    p {
      font-size: 1rem;
      font-weight: 500;
      margin: 15px 0 3px;

      span {
        font-size: 0.8rem;
        color: #455a64;
      }
    }

    span {
      font-size: 0.8rem;
      font-weight: 500;
      color: #455a64;
      text-align: end;
      width: 100%;
      padding: 5px 10px 0 0;
    }
  }
`;
